<template>
    <div class="table-responsive">
        <table class="table table-payments">
            <thead>
                <th>
                    <div class="wrapper-th-sortable">
                        <div class="name-th"
                            @click="changeSortFromName('nro_payment')"
                        >ID de orden</div>
                        <div class="sort-icons">
                            <i class="el-icon-caret-top"
                                :class="{ 'active-sort': isActiveSort('nro_payment', 'asc') }"
                                @click="changeSort('nro_payment', 'asc')"
                            ></i>
                            <i class="el-icon-caret-bottom"
                                :class="{ 'active-sort': isActiveSort('nro_payment', 'desc') }"
                                @click="changeSort('nro_payment', 'desc')"
                            ></i>
                        </div>
                    </div>
                </th>
                <th>
                    <div class="wrapper-th-sortable">
                        <div class="name-th"
                            @click="changeSortFromName('client')"
                        >Cliente</div>
                        <div class="sort-icons">
                            <i class="el-icon-caret-top"
                                :class="{ 'active-sort': isActiveSort('client', 'asc') }"
                                @click="changeSort('client', 'asc')"
                            ></i>
                            <i class="el-icon-caret-bottom"
                                :class="{ 'active-sort': isActiveSort('client', 'desc') }"
                                @click="changeSort('client', 'desc')"
                            ></i>
                        </div>
                    </div>
                </th>
                <th>
                    <div class="wrapper-th-sortable">
                        <div class="name-th"
                            @click="changeSortFromName('payment')"
                        >Monto</div>
                        <div class="sort-icons">
                            <i class="el-icon-caret-top"
                                :class="{ 'active-sort': isActiveSort('payment', 'asc') }"
                                @click="changeSort('payment', 'asc')"
                            ></i>
                            <i class="el-icon-caret-bottom"
                                :class="{ 'active-sort': isActiveSort('payment', 'desc') }"
                                @click="changeSort('payment', 'desc')"
                            ></i>
                        </div>
                    </div>
                </th>
                <th>
                    <div class="wrapper-th-sortable">
                        <div class="name-th"
                            @click="changeSortFromName('date_of_due')"
                        >Fecha de gracia</div>
                        <div class="sort-icons">
                            <i class="el-icon-caret-top"
                                :class="{ 'active-sort': isActiveSort('date_of_due', 'asc') }"
                                @click="changeSort('date_of_due', 'asc')"
                            ></i>
                            <i class="el-icon-caret-bottom"
                                :class="{ 'active-sort': isActiveSort('date_of_due', 'desc') }"
                                @click="changeSort('date_of_due', 'desc')"
                            ></i>
                        </div>
                    </div>
                </th>
                <th>
                    <div class="wrapper-th-sortable">
                        <div class="name-th"
                            @click="changeSortFromName('date_of_payment')"
                        >Fecha de pago</div>
                        <div class="sort-icons">
                            <i class="el-icon-caret-top"
                                :class="{ 'active-sort': isActiveSort('date_of_payment', 'asc') }"
                                @click="changeSort('date_of_payment', 'asc')"
                            ></i>
                            <i class="el-icon-caret-bottom"
                                :class="{ 'active-sort': isActiveSort('date_of_payment', 'desc') }"
                                @click="changeSort('date_of_payment', 'desc')"
                            ></i>
                        </div>
                    </div>
                </th>
                <th>
                    <div class="wrapper-th-sortable">
                        <div class="name-th">Estado</div>
                    </div>
                </th>
                <th>
                    <div class="wrapper-th-sortable">
                        <div class="name-th">Notificaciones</div>
                    </div>
                </th>
                <th>
                    <div class="wrapper-th-sortable">
                        <div class="name-th">Subir pago</div>
                    </div>
                </th>
                <th>
                    <div class="wrapper-th-sortable">
                        <div class="name-th">Verificar Pago</div>
                    </div>
                </th>
                <th>
                    <div class="wrapper-th-sortable">
                        <div class="name-th">Acciones</div>
                    </div>
                </th>
            </thead>

            <tbody>
                <slot name="tbody"></slot>
                <slot v-if="empty">
                    <tr>
                        <td colspan="8">
                            <div style="width: 100%; display: flex; align-items: center; justify-content: center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"><path fill="currentColor" d="M11.8 21q-1.05-.025-2.562-.238t-2.9-.687t-2.363-1.237T3 17v-2.5q0 .9.713 1.588t1.787 1.15t2.363.75t2.412.412q.225.725.613 1.388T11.8 21m-1.775-5.125q-1.125-.125-2.363-.413T5.389 14.7t-1.713-1.137T3 12V9.5q0 .95.788 1.65t1.95 1.188t2.525.75t2.487.362q-.3.55-.488 1.163t-.237 1.262M12 11q-3.725 0-6.363-1.175T3 7t2.638-2.825T12 3q3.75 0 6.375 1.175T21 7t-2.625 2.825T12 11m4.5 10q-1.875 0-3.187-1.312T12 16.5t1.313-3.187T16.5 12t3.188 1.313T21 16.5q0 .65-.187 1.25T20.3 18.9l2 2q.275.275.275.7t-.275.7t-.7.275t-.7-.275l-2-2q-.55.325-1.15.513T16.5 21m1.775-2.725Q19 17.55 19 16.5t-.725-1.775T16.5 14t-1.775.725T14 16.5t.725 1.775T16.5 19t1.775-.725"/></svg>
                                <div>
                                    No hay información para mostrar
                                </div>
                            </div>
                        </td>
                    </tr>
                </slot>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        props: {
            empty: {
                type: Boolean,
                default: true
            }
        },

        data() {
            return {
                sortBy: null,
                sortOrder: null
            }
        },

        methods: {
            resetSort() {
                this.sortBy = null
                this.sortOrder = null
            },
            
            changeSort(column, order) {
                this.sortBy = column
                this.sortOrder = order

                this.$emit('sort-change', {
                    sort_by: column,
                    sort_order: order
                })
            },

            changeSortFromName(column) {
                this.sortBy = column
                const current_order = this.sortOrder
                switch (current_order) {
                    case null:
                        this.sortOrder = 'asc'
                        break;
                    case 'asc':
                        this.sortOrder = 'desc'
                        break;
                    case 'desc':
                        this.sortOrder = null
                        break;
                }

                this.$emit('sort-change', {
                    sort_by: column,
                    sort_order: this.sortOrder
                })
            },

            isActiveSort(column, order) {
                return this.sortBy === column && this.sortOrder === order
            }
        },
    }
</script>

<style>
    .wrapper-th-sortable {
        width: 100%;
        display: flex;
        column-gap: 5px;
        align-items: center;
        justify-content: center;
    }

    .sort-icons {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        line-height: 1;
        color: #c0c4cc;
    }

    .sort-icons i {
        display: block;
        height: 7px;
        line-height: 7px;
        margin: 0.6px 0;
        padding: 0;
        cursor: pointer;
        font-size: 15px;
    }

    .active-sort {
        color: #409eff;
    }

    .name-th {
        cursor: pointer;
        font-weight: 700;
        user-select: none;
    }

    .table-payments td  {
        font-size: 11px;
    }
</style>


// WEBPACK FOOTER //
// resources/js/views/system/payments/components/table.vue